import { AppBar, Stack, useTheme } from '@mui/material'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { AuthSelector } from '../../store/auth'
import { GrantMatch } from '../icons'
import { CommonNavigation } from '../navigation/commonNavigation'

export const AuthHeader = () => {
  const theme = useTheme()
  const isLoggedIn = useSelector(AuthSelector.isLoggedIn)

  return (
    <AppBar color="transparent" position="relative" elevation={0}>
      <Stack
        direction="row"
        height="60px"
        alignItems="center"
        spacing={1}
        component="header"
        sx={{
          background: 'white',
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          padding: '0 1.5rem',
          justifyContent: 'space-between',
        }}
      >
        <Stack direction="row">
          <NavLink to={isLoggedIn ? '/home' : '/welcome'}>
            <GrantMatch sx={{ fontSize: '7rem' }} />
          </NavLink>
        </Stack>
        <Stack direction="row" flexGrow={1} justifyContent="flex-end" height="100%">
          <CommonNavigation />
        </Stack>
      </Stack>
    </AppBar>
  )
}
